export const ADMIN_CONFIG = {
  concerts: {
    name: "concerts",
    label: "concert",
    title: (x) => x.title,
    subtitle: (x) => `${x.date} · ${x.time} · ${x.venue}, ${x.city} · $${x.price} · ${x.tickets_sold}/${x.capacity} sold`,
    fields: [
      { name: "title", label: "Title", required: true },
      { name: "date", label: "Date", type: "date", required: true },
      { name: "time", label: "Time", type: "time", default: "20:00" },
      { name: "venue", label: "Venue", required: true },
      { name: "city", label: "City", required: true },
      { name: "price", label: "Ticket price ($)", type: "number", required: true, step: "0.01" },
      { name: "capacity", label: "Capacity", type: "number", required: true, default: 200 },
      { name: "image_url", label: "Image", type: "image" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  merch: {
    name: "merch",
    label: "merch item",
    title: (x) => x.name,
    subtitle: (x) => `$${x.price} · ${x.category}${x.sizes.length ? " · " + x.sizes.join("/") : ""}${x.active ? "" : " · hidden"}`,
    fields: [
      { name: "name", label: "Name", required: true },
      { name: "price", label: "Price ($)", type: "number", required: true, step: "0.01" },
      { name: "category", label: "Category", default: "Apparel" },
      { name: "sizes", label: "Sizes (comma separated, leave empty for one size)", type: "list", default: [] },
      { name: "image_url", label: "Image", type: "image" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "active", label: "Show in store", type: "checkbox", default: true },
    ],
  },
  gallery: {
    name: "gallery",
    label: "photo",
    title: (x) => x.caption || "Untitled photo",
    subtitle: (x) => x.category,
    fields: [
      { name: "image_url", label: "Photo", type: "image", required: true },
      { name: "caption", label: "Caption" },
      { name: "category", label: "Category", default: "Live" },
    ],
  },
};
